import { ReactElement, useState } from 'react'
import Stage1 from '../stages/TonnoStage1'
import Stage2 from '../stages/TonnoStage2'
import Stage3 from '../stages/TonnoStage3'
import Stage4 from '../stages/TonnoStage4'
import Stage5 from '../stages/TonnoStage5'
import FailModal from '../components/FailModal'

const Tonno = (): ReactElement => {
  const [stage, _setStage] = useState<number>(1)
  const [showModal, setShowModal] = useState(false)

  const setStage = (stageIndex: number) => {
    if (stageIndex === 0) {
      setShowModal(true)
      return
    }
    _setStage(stageIndex)
    window.scrollTo(0, 0)
  }

  return (
    <div>
      {stage === 1 && <Stage1 onStageChange={setStage} />}
      {stage === 2 && <Stage2 onStageChange={setStage} />}
      {stage === 3 && <Stage3 onStageChange={setStage} />}
      {stage === 4 && <Stage4 onStageChange={setStage} />}
      {stage === 5 && <Stage5 onStageChange={setStage} />}
      {showModal && <FailModal onClose={() => setShowModal(false)} />}
    </div>
  )
}

export default Tonno
